import axios from "axios";
import {
  projectAuth,
  projectFirestore,
  projectStorage,
} from "../../src/firebase/config";
import {
  signInWithPopup,
  GoogleAuthProvider,
  signInWithEmailAndPassword,
  EmailAuthProvider,
  reauthenticateWithCredential,
} from "firebase/auth";
import {
  doc,
  addDoc,
  updateDoc,
  deleteDoc,
  getDoc,
  collection,
  getCountFromServer,
  getDocs,
  setDoc,
  query,
  where,
  orderBy,
} from "firebase/firestore";
import { ref, uploadBytes, getDownloadURL } from "firebase/storage";

const utilGetDocument = async (documentoRef) => {
  try {
    const documentoSnap = await getDoc(documentoRef);
    if (documentoSnap.exists()) {
      const datos = documentoSnap.data();
      datos.id = documentoSnap.uid;
      //console.log('Datos del documento:', datos);
      return datos;
    } else {
      console.log("El documento no existe");
      return null;
    }
  } catch (error) {
    console.error("Error al obtener el documento:", error);
    return null;
  }
};

const utilGetDocumentFilters = async (coleccion, filtros) => {
  try {
    const colRef = collection(projectFirestore, coleccion);
    let q = query(colRef);
    filtros.forEach((filtro) => {
      const { campo, operador, valor } = filtro;
      q = query(q, where(campo, operador, valor));
    });
    if (coleccion === "checador") {
      q = query(q, orderBy("start_date", "desc"));
    }
    const querySnapshot = await getDocs(q);
    const documentosColeccion = [];
    querySnapshot.forEach((doc) => {
      const data = doc.data();
      data.id = doc.id;
      documentosColeccion.push(data);
    });
    return documentosColeccion;
  } catch (error) {
    console.error("Error al buscar documentos:", error);
  }
};

const utilGetQtyDocumentFilters = async (coleccion, filtros) => {
  try {
    const colRef = collection(projectFirestore, coleccion);
    let q = query(colRef);

    const querySnapshot = await getDocs(q);
    const cantidadDocumentos = querySnapshot.size;

    return cantidadDocumentos;
  } catch (error) {
    console.error("Error al buscar documentos:", error);
  }
};

const utilGetCollection = async (nombreColeccion) => {
  try {
    const coleccionRef = collection(projectFirestore, nombreColeccion);
    const coleccionSnapshot = await getDocs(coleccionRef);
    const documentosColeccion = [];
    coleccionSnapshot.forEach((documento) => {
      const datos = documento.data();
      datos.id = documento.id;
      documentosColeccion.push(datos);
    });
    return documentosColeccion;
  } catch (error) {
    console.error("Error al obtener la colección:", error);
    return [];
  }
};

const utilGetCollectionFilter = async (
  nombreColeccion,
  filtroCampo,
  filtroOperador,
  referencia,
) => {
  try {
    const coleccionRef = collection(projectFirestore, nombreColeccion);
    // Crear una consulta con el filtro de referencia
    const consulta = query(
      coleccionRef,
      where(filtroCampo, filtroOperador, referencia),
    );
    const coleccionSnapshot = await getDocs(consulta);
    const documentosColeccion = [];
    coleccionSnapshot.forEach((documento) => {
      const datos = documento.data();
      const id = documento.id; // Obtener el ID del documento
      const documentoConId = { id, ...datos };
      documentosColeccion.push(documentoConId);
    });
    console.log("Documentos de la colección:", documentosColeccion);
    return documentosColeccion;
  } catch (error) {
    console.error("Error al obtener la colección:", error);
    return [];
  }
};

const getFolioVenta = async (idRest) => {
  const coleccionRef = collection(projectFirestore, "turnero");
  const consulta = query(coleccionRef, where("puesto", "==", idRest));
  const coleccionSnapshot = await getCountFromServer(consulta);
  return coleccionSnapshot.data();
};

const utilGetCollectionFilterReference = async (
  nombreColeccion,
  filtroCampo,
  filtroOperador,
  referencia,
  nombreRefenrencia,
) => {
  try {
    const documentosColeccion = [];
    const documentoRef = await doc(
      projectFirestore,
      nombreRefenrencia,
      referencia,
    );
    const coleccionRef = collection(projectFirestore, nombreColeccion);
    const consulta = query(
      coleccionRef,
      where(filtroCampo, filtroOperador, documentoRef),
    );
    const coleccionSnapshot = await getDocs(consulta);
    coleccionSnapshot.forEach((documento) => {
      const datos = documento;
      documentosColeccion.push(datos);
    });
    //console.log('Documentos de la colección:', documentosColeccion);
    return documentosColeccion;
  } catch (error) {
    console.error("Error al obtener la colección:", error);
    return [];
  }
};

const utilGetSubCollection = async (
  nombreColeccionPadre,
  idDocumentoPadre,
  nombreSubcoleccion,
) => {
  try {
    const documentoRef = doc(
      projectFirestore,
      nombreColeccionPadre,
      idDocumentoPadre,
    );
    const subcoleccionRef = collection(documentoRef, nombreSubcoleccion);
    const subcoleccionSnapshot = await getDocs(subcoleccionRef);
    const documentosSubcoleccion = [];
    subcoleccionSnapshot.forEach((documento) => {
      const datos = documento.data();
      datos.id = documento.id;
      documentosSubcoleccion.push(datos);
    });
    return documentosSubcoleccion;
  } catch (error) {
    console.error("Error al obtener la subcolección:", error);
    return [];
  }
};

const utilGetSubCollectionReference = async (
  nombreColeccionPadre,
  idDocumentoPadre,
  nombreSubcoleccion,
  referencia,
  nombreRefenrencia,
) => {
  try {
    const documentoRef = doc(
      projectFirestore,
      nombreColeccionPadre,
      idDocumentoPadre,
    );
    const subcoleccionRef = collection(documentoRef, nombreSubcoleccion);
    // Obtener la referencia del documento objetivo
    const referenciaDocumento = await doc(
      projectFirestore,
      nombreRefenrencia,
      referencia,
    );
    // Crear una consulta con el filtro de referencia
    const consulta = query(
      subcoleccionRef,
      where("categoria", "==", referenciaDocumento),
    );
    const subcoleccionSnapshot = await getDocs(consulta);
    const documentosSubcoleccion = [];
    subcoleccionSnapshot.forEach((documento) => {
      const datos = documento.data();
      datos.id = documento.id;
      documentosSubcoleccion.push(datos);
    });
    //console.log('Documentos de la subcolección filtrados por referencia:', documentosSubcoleccion);
    return documentosSubcoleccion;
  } catch (error) {
    console.error("Error al buscar la subcolección:", error);
    return [];
  }
};

const utilGetDocumentById = async (coleccion, id) => {
  try {
    const docRef = doc(projectFirestore, coleccion, id);
    const docSnap = await getDoc(docRef);

    if (docSnap.exists()) {
      const datos = docSnap.data();
      datos.id = docSnap.id;
      return datos;
    } else {
      console.log("El documento no existe");
      return null;
    }
  } catch (error) {
    console.error("Error al obtener el documento:", error);
    return null;
  }
};

const utilSignInWithGoogle = async () => {
  try {
    const provider = new GoogleAuthProvider();
    const user = await signInWithPopup(projectAuth, provider)
      .then(async (result) => {
        // El inicio de sesión fue exitoso
        const user = {
          id: result.user.uid,
          email: result.user.email,
          fullName: result._tokenResponse.fullName,
          type: "user-web",
        };
        const filtros = [
          { campo: "id", operador: "==", valor: result.user.uid },
        ];
        const users = await utilGetDocumentFilters("users", filtros);
        if (users.length === 0) {
          utilCreateDocument("users", user);
        }
        return user;
      })
      .catch((error) => {
        console.log(error);
      });
    return user;
  } catch (error) {
    console.error(error);
  }
};

const utilCreateUserWithEmailAndPassword = async (email, fullName) => {
  var credential = EmailAuthProvider.credential(
    email,
    window.localStorage.getItem("password"),
  );
  const userd = await reauthenticateWithCredential(
    projectAuth.currentUser,
    credential,
  )
    .then(async (userCredential) => {
      window.localStorage.removeItem("password");
      const user = {
        id: userCredential.user.uid,
        email: userCredential.user.email,
        fullName: fullName,
        type: "user-web",
      };
      const filtros = [
        { campo: "id", operador: "==", valor: userCredential.user.uid },
      ];
      const users = await utilGetDocumentFilters("users", filtros);
      if (users.length === 0) {
        utilCreateDocument("users", user);
      }
      return user;
    })
    .catch(async (error) => {
      try {
        const user = {
          id: projectAuth.currentUser.uid,
          email: projectAuth.currentUser.email,
          fullName: fullName,
          type: "user-web",
        };
        const filtros = [
          { campo: "id", operador: "==", valor: projectAuth.currentUser.uid },
        ];
        const users = await utilGetDocumentFilters("users", filtros);
        if (users.length === 0) {
          utilCreateDocument("users", user);
        }
        return user;
      } catch (error) {
        console.error(error);
        return null;
      }
    });
  return userd;
};

const utilSignInWithEmailAndPassword = async (email, password) => {
  const user = await signInWithEmailAndPassword(projectAuth, email, password)
    .then(async (userCredential) => {
      const user = {
        id: userCredential.user.uid,
        email: userCredential.user.email,
        //fullName: userCredential._tokenResponse.fullName,
        type: "user-web",
      };
      return user;
    })
    .catch((error) => {
      // Ocurrió un error al crear el usuario
      console.error(error);
      return null;
    });
  return user;
};

const utilCreateDocument = async (coleccion, datos) => {
  try {
    const docRef = await addDoc(collection(projectFirestore, coleccion), datos);
    return docRef;
  } catch (error) {
    console.error("Error al agregar el documento:", error);
  }
};

const utilCreateDocumentWithIdReference = async (
  mainCollection,
  mainDocData,
  referenceCollection,
  IdReferenceCollection,
) => {
  try {
    const usuarioRef = doc(
      collection(projectFirestore, referenceCollection),
      IdReferenceCollection,
    );
    mainDocData.user = usuarioRef;
    const registroRef = await addDoc(
      collection(projectFirestore, mainCollection),
      mainDocData,
    );
    return registroRef.id;
  } catch (error) {
    console.error('Error al guardar el documento "registro"', error);
  }
};

const utilCreateInventario = async (mainDocData, IdReferenceCollection) => {
  try {
    const usuarioRef = doc(
      collection(projectFirestore, "registro"),
      IdReferenceCollection,
    );
    mainDocData.registro = usuarioRef;
    const registroRef = await addDoc(
      collection(projectFirestore, "inventario"),
      mainDocData,
    );
    const invRef = doc(collection(registroRef, "Productos"));
    setDoc(invRef, {
      Nombre: "",
      "Tipo de unidad": "",
      Cantidad: 0,
    });
    return registroRef.id;
  } catch (error) {
    console.error('Error al guardar el documento "registro"', error);
  }
};

const utilCreateProductoInventario = async (mainDocData, inventarioId) => {
  try {
    const menuRef = doc(projectFirestore, "inventario", inventarioId);
    const coleccion = collection(menuRef, "Productos");
    const registroRef = await addDoc(coleccion, mainDocData);
    return registroRef.id;
  } catch (error) {
    console.error('Error al guardar el documento "registro"', error);
  }
};

const utilCreateProductosInventario = async (inventarioId, producto) => {
  try {
    const menuRef = doc(
      collection(projectFirestore, "inventario", inventarioId, "Productos"),
    );
    const documentRef = await addDoc(menuRef, producto);
    const documentSnapshot = await getDoc(documentRef);
    let result = documentSnapshot.data();
    result.id = documentSnapshot.id;
    return menuRef;
  } catch (error) {
    console.error("Error al agregar la categoría a Firebase:", error);
  }
};

const utilUpdateProductoInventario = async (InventarioId, producto) => {
  try {
    const categoriaRef = doc(
      projectFirestore,
      "inventario",
      InventarioId,
      "Productos",
      producto.id,
    );
    await updateDoc(categoriaRef, producto);
  } catch (error) {
    console.error("Error al agregar la categoría a Firebase:", error);
  }
};

const utilDeleteProductoInventario = async (inventarioId, producto) => {
  try {
    const categoriaRef = doc(
      projectFirestore,
      "inventario",
      inventarioId,
      "Productos",
      producto.id,
    );
    await deleteDoc(categoriaRef);
  } catch (error) {
    console.error("Error al agregar la categoría a Firebase:", error);
  }
};

const utilCreateDocumentWithIdReferenceData = async (
  mainCollection,
  mainDocData,
  referenceData,
) => {
  try {
    referenceData.forEach((element) => {
      const documentRef = doc(
        collection(projectFirestore, element.nameCollection),
        element.id,
      );
      const name = element.nameField;
      const val = documentRef;
      mainDocData = createJSONField(name, val, mainDocData);
    });
    const registroRef = await addDoc(
      collection(projectFirestore, mainCollection),
      mainDocData,
    );
    const documentSnapshot = await getDoc(registroRef);
    let result = documentSnapshot.data();
    result.id = documentSnapshot.id;
    return result;
  } catch (error) {
    console.error('Error al guardar el documento "registro"', error);
  }
};

const utilCreateSubcolletcionWithDoc = async (
  docRefId,
  docRefName,
  newSubCollectionName,
  newDocsinSubArray,
) => {
  try {
    const colectionRef = await collection(
      projectFirestore,
      docRefName,
      docRefId,
      newSubCollectionName,
    );
    newDocsinSubArray.forEach(async (data) => {
      try {
        await addDoc(colectionRef, data);
      } catch (error) {
        console.error("Error al crear el documento:", error);
      }
    });
  } catch (error) {
    console.error("Error al crear coleccion", error);
  }
};

function createJSONField(key, value, existingJSON) {
  const newJSON = { ...existingJSON };
  newJSON[key] = value;
  return newJSON;
}

const utilUpdateDocument = async (collectionName, documentId, data) => {
  const docRef = doc(projectFirestore, collectionName, documentId);
  try {
    await updateDoc(docRef, data);
    console.log("Documento actualizado en Firebase");
    return true;
  } catch (error) {
    console.error("Error al actualizar el documento:", error);
    return false;
  }
};

const saveImageToFirebaseStorage = async (path, imageFile) => {
  try {
    const url = path + "/" + imageFile.name;
    const storageRef = ref(projectStorage, url);
    await uploadBytes(storageRef, imageFile);
    // Get the download URL of the uploaded image
    const downloadURL = await getDownloadURL(storageRef);
    console.log("Image uploaded successfully!");
    return downloadURL;
  } catch (error) {
    console.error("Error uploading image:", error);
    return null;
  }
};

const updateActiveDisabledAccount = async (uid, active) => {
  try {
    /*
    await updateUser(uid, {
      disabled: active,
    })
    .then((userRecord) => {
      // See the UserRecord reference doc for the contents of userRecord.
      console.log('Successfully updated user', userRecord.toJSON());
    })
    .catch((error) => {
      console.log('Error updating user:', error);
    });
  */
  } catch (error) {
    console.error("Error uploading image:", error);
    return null;
  }
};

const utilCreateTables = async (Mesas, idPuesto) => {
  try {
    let dato = { id_puesto: idPuesto };

    const registroRef = await addDoc(
      collection(projectFirestore, "mesas"),
      dato,
    );

    const invRef = doc(collection(registroRef, "asignaciones"));

    let ArrMesas = {};
    for (let index = 0; index < Mesas; index++) {
      let numMesa = index + 1;
      ArrMesas["Mesa " + numMesa] = { Mesero: "", no_molestar: false };
    }

    // Crear un nuevo documento en la colección "menu"
    await setDoc(invRef, ArrMesas);

    console.log("Documento con colecciones creadas exitosamente.");
  } catch (error) {
    console.error("Error al crear el documento con colecciones:", error);
  }
};
const utilUpdateTables = async (Mesas, idPuesto) => {
  try {
    const fetchOrders = await utilGetCollectionFilter(
      "mesas",
      "id_puesto",
      "==",
      idPuesto,
    );
    if (fetchOrders.length === 0) {
      utilCreateTables(Mesas, idPuesto);
    } else {
      const categoriaSnapshot = await getDocs(
        collection(
          doc(projectFirestore, "mesas", fetchOrders[0].id),
          "asignaciones",
        ),
      );
      if (categoriaSnapshot.docs.length > 0) {
        const categorias = categoriaSnapshot.docs.map((doc) => {
          let data = doc.data();
          data.id = doc.id;
          return data;
        });
        await deleteDoc(
          doc(
            projectFirestore,
            "mesas",
            fetchOrders[0].id,
            "asignaciones",
            categorias[0].id,
          ),
        );
        delete categorias[0].id;
        let ArrMesas = categorias[0];
        if (Object.keys(ArrMesas).length < Mesas) {
          for (
            let index = Object.keys(ArrMesas).length;
            index < Mesas;
            index++
          ) {
            let numMesa = index + 1;
            categorias[0]["Mesa " + numMesa] = {
              Mesero: "",
              no_molestar: false,
            };
          }
          await setDoc(
            doc(
              collection(
                doc(projectFirestore, "mesas", fetchOrders[0].id),
                "asignaciones",
              ),
            ),
            ArrMesas,
          );
        } else if (Object.keys(ArrMesas).length > Mesas) {
          for (
            let index = Object.keys(ArrMesas).length;
            index > Mesas;
            index--
          ) {
            let numMesa = index;
            delete categorias[0]["Mesa " + numMesa];
          }
          await setDoc(
            doc(
              collection(
                doc(projectFirestore, "mesas", fetchOrders[0].id),
                "asignaciones",
              ),
            ),
            ArrMesas,
          );
        } else {
          await setDoc(
            doc(
              collection(
                doc(projectFirestore, "mesas", fetchOrders[0].id),
                "asignaciones",
              ),
            ),
            ArrMesas,
          );
        }
      }
      // Crear un nuevo documento en la colección "menu"
    }
    console.log("Documento con colecciones creadas exitosamente.");
  } catch (error) {
    console.error("Error al crear el documento con colecciones:", error);
  }
};

const utilCreateDocumentMenuWithCollections = async (
  datos,
  categorias,
  platillos,
  referenceData,
) => {
  try {
    referenceData.forEach((element) => {
      const documentRef = doc(
        collection(projectFirestore, element.nameCollection),
        element.id,
      );
      const name = element.nameField;
      const val = documentRef;
      datos = createJSONField(name, val, datos);
    });

    // Crear un nuevo documento en la colección "menu"
    const menuRef = await addDoc(collection(projectFirestore, "menu"), datos);

    // Crear documentos en la colección "categoria" dentro del nuevo documento del menú
    for (const categoria of categorias) {
      const categoriaRef = doc(collection(menuRef, "categoria"));
      await setDoc(categoriaRef, categoria);

      // Crear documentos en la colección "platillo" dentro del nuevo documento del menú
      for (const platillo of platillos) {
        // Agregar la referencia a la categoría en cada platillo
        const platilloRef = doc(collection(menuRef, "platillo"));
        await setDoc(platilloRef, {
          ...platillo,
          categoria: ref(categoriaRef),
        });
      }
    }

    datos.id = menuRef.id;

    // Actualizar el documento del menú con otros datos proporcionados
    await setDoc(doc(projectFirestore, "menu", menuRef.id), datos, {
      merge: true,
    });

    console.log("Documento con colecciones creadas exitosamente.");
  } catch (error) {
    console.error("Error al crear el documento con colecciones:", error);
  }
};
const utilGetMeseros = async (idMesero) => {
  try {
    const docRef = doc(projectFirestore, "users", idMesero);
    const docSnapshot = await getDoc(docRef);

    if (docSnapshot.exists()) {
      const data = docSnapshot.data();

      return data;
    } else {
      console.log("El documento del menú no existe.");
      return null;
    }
  } catch (error) {
    console.error("Error al obtener el documento del menú:", error);
    return null;
  }
};

const utilGetInventario = async (inventarioID) => {
  try {
    const docRef = doc(projectFirestore, "inventario", inventarioID);
    const docSnapshot = await getDoc(docRef);

    if (docSnapshot.exists()) {
      const data = docSnapshot.data();

      const categoriaSnapshot = await getDocs(collection(docRef, "Productos"));

      const categorias = categoriaSnapshot.docs.map((doc) => {
        let data = doc.data();
        data.id = doc.id;
        return data;
      });

      // Combinar los datos del menú con las colecciones
      const menuDataWithCollections = {
        ...data,
        productos: categorias,
      };

      return menuDataWithCollections;
    } else {
      console.log("El documento del menú no existe.");
      return null;
    }
  } catch (error) {
    console.error("Error al obtener el documento del menú:", error);
    return null;
  }
};

const utilGetMesas = async (idMesas) => {
  try {
    const docRef = doc(projectFirestore, "mesas", idMesas);
    const docSnapshot = await getDoc(docRef);

    if (docSnapshot.exists()) {
      const data = docSnapshot.data();

      const categoriaSnapshot = await getDocs(
        collection(docRef, "asignaciones"),
      );

      const categorias = categoriaSnapshot.docs.map((doc) => {
        let data = doc.data();
        data.id = doc.id;
        return data;
      });

      // Combinar los datos del menú con las colecciones
      const menuDataWithCollections = {
        ...data,
        asignaciones: categorias,
      };

      return menuDataWithCollections;
    } else {
      console.log("El documento de la mesa no existe.");
      return null;
    }
  } catch (error) {
    console.error("Error al obtener el documento de la mesa:", error);
    return null;
  }
};

const utilGetMenu = async (menuId) => {
  try {
    const docRef = doc(projectFirestore, "menu", menuId);
    const docSnapshot = await getDoc(docRef);

    if (docSnapshot.exists()) {
      const data = docSnapshot.data();

      const categoriaSnapshot = await getDocs(collection(docRef, "categoria"));
      const platilloSnapshot = await getDocs(collection(docRef, "platillo"));

      const categorias = categoriaSnapshot.docs.map((doc) => {
        let data = doc.data();
        data.id = doc.id;
        return data;
      });

      const platillos = await Promise.all(
        platilloSnapshot.docs.map(async (doc) => {
          let data = doc.data();
          const categoriaRef = doc.get("categoria");
          const categoriaSnapshot = await getDoc(categoriaRef);
          const categoriaData = categoriaSnapshot.data();
          data.categoria = categoriaData;
          data.id = doc.id;
          data.refDoc = doc.ref;
          return data;
        }),
      );

      // Combinar los datos del menú con las colecciones
      const menuDataWithCollections = {
        ...data,
        categoria: categorias,
        platillo: platillos,
      };

      return menuDataWithCollections;
    } else {
      console.log("El documento del menú no existe.");
      return null;
    }
  } catch (error) {
    console.error("Error al obtener el documento del menú:", error);
    return null;
  }
};

const utilCreateCategoriaMenu = async (menuId, categoria) => {
  try {
    const menuRef = doc(projectFirestore, "menu", menuId);

    const categoriaRef = collection(menuRef, "categoria");

    const documentRef = await addDoc(categoriaRef, categoria);

    const documentSnapshot = await getDoc(documentRef);

    let result = documentSnapshot.data();

    result.id = documentSnapshot.id;

    return result;
  } catch (error) {
    console.error("Error al agregar la categoría a Firebase:", error);
  }
};

const utilUpdateCategoriaMenu = async (menuId, categoria) => {
  try {
    const categoriaRef = doc(
      projectFirestore,
      "menu",
      menuId,
      "categoria",
      categoria.id,
    );

    await updateDoc(categoriaRef, categoria);
  } catch (error) {
    console.error("Error al agregar la categoría a Firebase:", error);
  }
};

const utilDeleteCategoriaMenu = async (menuId, categoria) => {
  try {
    const categoriaRef = doc(
      projectFirestore,
      "menu",
      menuId,
      "categoria",
      categoria.id,
    );

    await deleteDoc(categoriaRef);
  } catch (error) {
    console.error("Error al agregar la categoría a Firebase:", error);
  }
};

const utilDeleteAllPlatillosCategoria = async (menuId, categoriaId) => {
  try {
    // Obtener la referencia a la colección de platillos dentro de la categoría
    const platillosRef = collection(
      projectFirestore,
      "menu",
      menuId,
      "platillo",
    );

    // Crear una consulta para obtener todos los platillos de la categoría
    const consulta = query(
      platillosRef,
      where(
        "categoria",
        "==",
        doc(projectFirestore, "menu", menuId, "categoria", categoriaId),
      ),
    );

    // Obtener los documentos que coinciden con la consulta
    const platillosSnapshot = await getDocs(consulta);

    // Eliminar cada platillo
    platillosSnapshot.forEach(async (platilloDoc) => {
      await deleteDoc(platilloDoc.ref);
    });

    console.log("Todos los platillos de la categoría han sido eliminados.");
  } catch (error) {
    console.error("Error al eliminar los platillos de la categoría:", error);
  }
};

const utilCreatePlatilloMenu = async (menuId, categoriaId, platillo) => {
  try {
    const menuRef = doc(projectFirestore, "menu", menuId);

    const categoriaRef = doc(
      projectFirestore,
      "menu",
      menuId,
      "categoria",
      categoriaId,
    );

    const platilloRef = doc(collection(menuRef, "platillo"));
    await setDoc(platilloRef, {
      ...platillo,
      categoria: ref(categoriaRef), // Agregar la referencia a la categoría
    });

    const documentSnapshot = await getDoc(platilloRef);

    let result = documentSnapshot.data();

    result.id = documentSnapshot.id;

    return result;
  } catch (error) {
    console.error("Error al agregar la categoría a Firebase:", error);
  }
};
const utilUpdateAsignaciones = async (
  MesasID,
  asignacionesID,
  asignaciones,
) => {
  try {
    const platilloRef = doc(
      projectFirestore,
      "mesas",
      MesasID,
      "asignaciones",
      asignacionesID,
    );

    await updateDoc(platilloRef, asignaciones);
  } catch (error) {
    console.error("Error al agregar la categoría a Firebase:", error);
  }
};

const utilUpdatePlatilloMenu = async (menuId, categoriaId, platillo) => {
  try {
    const platilloRef = doc(
      projectFirestore,
      "menu",
      menuId,
      "platillo",
      platillo.id,
    );

    const categoriaRef = doc(
      projectFirestore,
      "menu",
      menuId,
      "categoria",
      categoriaId,
    );

    await updateDoc(platilloRef, {
      ...platillo,
      categoria: ref(categoriaRef),
    });
  } catch (error) {
    console.error("Error al agregar la categoría a Firebase:", error);
  }
};

const utilDeletePlatilloMenu = async (menuId, platillo) => {
  try {
    const categoriaRef = doc(
      projectFirestore,
      "menu",
      menuId,
      "platillo",
      platillo.id,
    );
    await deleteDoc(categoriaRef);
  } catch (error) {
    console.error("Error al agregar la categoría a Firebase:", error);
  }
};

const addNotifyOrden = async (notificacion) => {
  try {
    await addDoc(collection(projectFirestore, "notificaciones"), notificacion);
    if (notificacion.user) {
      const fcmToken = (
        await getDoc(doc(projectFirestore, "users", notificacion.user))
      ).data().fcmToken;
      if (fcmToken) {
        const message = {
          notification: {
            title: notificacion.puesto_name,
            body: notificacion.description,
          },
          data: {
            click_action: "FLUTTER_NOTIFICATION_CLICK",
            id: "1",
            status: "done",
          },
          android: {
            priority: "high",
            notification: {
              sound: "default",
            },
          },
          token: fcmToken,
        };
        const resp = await axios.post(
          "https://us-central1-rap-dis.cloudfunctions.net/default/create_notifi",
          {
            message: message,
          },
        );
        console.log("Respuesta del servidor de notificaciones:", resp.data);
      }
    }
  } catch (error) {
    console.error("Error al actualizar el documento:", error);
  }
};

const getConsecutivoTurnero = async (puesto) => {
  try {
    const currentDate = new Date();
    currentDate.setUTCHours(0, 0, 0, 0);
    console.log(currentDate.toISOString());

    const filtros = [
      { campo: "puesto", operador: "==", valor: puesto },
      { campo: "fecha", operador: "==", valor: currentDate.toISOString() },
    ];

    const dataConsecutivo = await utilGetDocumentFilters(
      "turnero_consecutivo",
      filtros,
    );

    let consecutivo = 1;

    if (dataConsecutivo.length > 0) {
      consecutivo = dataConsecutivo[0].consecutivo + 1;

      dataConsecutivo[0].consecutivo = consecutivo;

      utilUpdateDocument(
        "turnero_consecutivo",
        dataConsecutivo[0].id,
        dataConsecutivo[0],
      );
    } else {
      let datosConsecutivo = {
        consecutivo: consecutivo,
        fecha: currentDate.toISOString(),
        puesto: puesto,
      };

      utilCreateDocument("turnero_consecutivo", datosConsecutivo);
    }

    return consecutivo;
  } catch (error) {
    console.error("Error al generar consecutivo:", error);
  }
};

export {
  utilGetInventario,
  utilGetDocument,
  utilUpdateTables,
  utilGetDocumentFilters,
  utilGetCollection,
  utilGetCollectionFilter,
  utilGetCollectionFilterReference,
  utilGetSubCollection,
  utilGetSubCollectionReference,
  utilSignInWithGoogle,
  utilCreateUserWithEmailAndPassword,
  utilSignInWithEmailAndPassword,
  utilCreateDocument,
  utilGetQtyDocumentFilters,
  utilCreateDocumentWithIdReference,
  utilCreateDocumentWithIdReferenceData,
  utilUpdateDocument,
  saveImageToFirebaseStorage,
  updateActiveDisabledAccount,
  utilCreateSubcolletcionWithDoc,
  utilGetMenu,
  utilCreateDocumentMenuWithCollections,
  utilCreateCategoriaMenu,
  utilUpdateCategoriaMenu,
  utilDeleteCategoriaMenu,
  utilDeleteAllPlatillosCategoria,
  utilCreatePlatilloMenu,
  utilUpdatePlatilloMenu,
  utilDeletePlatilloMenu,
  addNotifyOrden,
  getConsecutivoTurnero,
  utilGetDocumentById,
  utilCreateInventario,
  utilCreateProductosInventario,
  utilDeleteProductoInventario,
  utilUpdateProductoInventario,
  utilCreateProductoInventario,
  utilGetMesas,
  utilGetMeseros,
  utilUpdateAsignaciones,
  getFolioVenta,
};
